export default __webpack_public_path__ + "static/media/myTest.84767a96.svg";